import { RiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<RiskLevel> = new Map([
  [
    Gender.unknown,
    new Map([
      [RiskLevel.Low, [{ lower: 0, upper: 4 }]],
      [RiskLevel.Medium, [{ lower: 5, upper: 19 }]],
      [RiskLevel.High, [{ lower: 20, upper: 27 }]],
    ]),
  ],
]);

export default referenceRange;
